import React, { Component } from "react";

import {
  CCol,
  CRow,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CInput
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import Breadcrumb from "../../components/Breadcrumb";
import Loading from "../../components/Loading";
import ChartUsers from "../../components/Statistics/StatisticsAccess/ChartUsers";
import ChartWhoAccess from "../../components/Statistics/StatisticsAccess/ChartWhoAccess";
import StatisticsAccessFilter from "../../components/Statistics/StatisticsAccess/StatisticsAccessFilter";
import TableAccess from "../../components/Statistics/StatisticsAccess/TableAccess";
import URL from "../../config/api";
import axios from "../../config/axios";

import "./style.scss";

class Management extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // list: [],
      loading: true,
      // applications: [],
      // menu: "Estatísticas da turma por atividade",
      // dropdownItems: false,
      // selectedRoom: { activities: [], users: [] },
      // rooms: [],
      selectedRoomId: "0",
      // selectedSchool: "0",
      selectedSchoolId: {},
      // schools: [],
      // selectedActivity: {},
      // selectedActivityId: "0",
      // activities: [],
      // activeAux: false,
      // selectedSectionSideBar: 0,

      selectedIds: { profileId: 0, schoolId: 0, groupId: 0, regionId: 0 },
      filterOptions: {
        profile: [
          { id: 0, name: "Todos" },
          { id: 1, name: "Professor" },
          { id: 2, name: "Aluno" }
        ],
        schools: [
          { id: 0, name: "Todos" },
          { id: 1, name: "Escola 1" },
          { id: 2, name: "Escola 2" }
        ],
        groups: [
          { id: 0, name: "Todos" },
          { id: 1, name: "Grupo 1" },
          { id: 2, name: "Grupo 2" }
        ],
        regions: [
          { id: 0, name: "Todos" },
          { id: 1, name: "Regiao 1" },
          { id: 2, name: "Regiao 2" }
        ]
      }
      // initialPeriod: 0,
      // finalPeriod: 0
    };
    this.changeSelectedFilter = this.changeSelectedFilter.bind(this);
  }

  changeSelectedFilter(newSelected) {
    this.setState({ selectedIds: newSelected });
  }

  getInfo() {
    return [];
  }

  async componentDidMount() {
    // fetch schools
    // n sabemos se rota existe ai esse codigo vai funcionar só pra professor e dps a gente ajeita]
    const { active_roles: activeRoles } = this.props.general;
    // se for professor seta automaticamente a escola
    if (activeRoles.type === "P") {
      const newSchoolObject = {
        id: activeRoles.school_id,
        name: activeRoles.school_name
      };
      this.setState({
        // schools: [newSchoolObject],
        selectedSchoolId: activeRoles.school_id
        // selectedSchool: newSchoolObject
      });
      this.selectSchool(this.state.selectedSchoolId);
    } else {
      // codigo pra buscar as escolas
      this.setState({ loading: false });
    }

    // axios.get(URL.api + 'access/school/listSchoolFilter/' + this.state.groupSelected +'/'+regionSelected,{headers:{'authorization':'Bearer '+this.props.user.token}})
    //   .then(
    //       (resp) => {
    //           if(resp.data.success){
    //             this.setState({
    //               scholl: resp.data.data,
    //               loading:false,
    //               regionSelected:regionSelected
    //             });

    //           }
    //           callback();
    //       },
    //       (error) => {
    //           if(error.response === "Unauthorized"){
    //                this.props.logout(this.props.user.token)
    //           }
    //       }
    //   )
  }

  // seleciona a sala que quer se analisar
  async selectRoom(roomId) {
    this.setState({ loading: true, selectedRoomId: roomId });
    if (roomId !== "0") {
      axios
        .get(`${URL.api}community/room/report?room_id=${roomId}`, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          // só muda a sala e tira o loading caso essa requisicao seja da sala desejada
          // resolve o problema do usuario mudar a sala desejada antes de uma requisicao terminar
          if (roomId === this.state.selectedRoomId) {
            this.setState({
              // selectedRoom: resp.data.data,
              loading: false
              // activities: resp.data.data.activities
            });
          }
        });
      // adiciona o loading e troca a variavel de estado para o select atualizar
    } else {
      this.setState({
        loading: false,
        selectedRoomId: roomId
        // menu: "Atividade Turma"
      });
    }
  }

  selectSchool(schoolId) {
    // pega todas as salas referentes a um usuario
    // tem que adicionar o filtro de escola
    axios
      .get(
        `${URL.api}community/room/listByUser?class=true&user=${this.props.user.user.id}`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          if (schoolId === this.state.selectedSchoolId) {
            this.setState({ loading: false });
          }
        },
        error => {
          this.error("Não foi possível carregar as turmas. Tente novamente");
        }
      );

    this.setState({
      loading: true,
      selectedSchoolId: schoolId
      // menu: "Assunto Avaliacao Escola"
    });
  }

  render() {
    return (
      <div className="d-flex flex-column align-items-left">
        <Breadcrumb current={this.props.currentRoute} />
        {/* FILTROS DE GRUPO, REGIÃO, ESCOLA, PERFIL */}
        <CRow className="mb-4">
          <CCol style={{ maxWidth: "100%" }}>
            <StatisticsAccessFilter
              filterOptions={this.state.filterOptions}
              selectedIds={this.state.selectedIds}
              changeSelected={this.changeSelectedFilter}
            />
          </CCol>
        </CRow>
        {/* FILTRO DE PERÍODO */}
        <CRow className="mb-4">
          <CCol style={{ maxWidth: "25%", marginBottom: "-15px" }}>
            <div>Período</div>
          </CCol>
        </CRow>
        <CRow className="mb-4">
          <CCol style={{ maxWidth: "25%" }}>
            <CFormGroup>
              <CInputGroup className="input-prepend">
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-calendar-o"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CInput
                  type="date"
                  value={this.state.birthday}
                  onChange={e =>
                    // eslint-disable-next-line react/no-unused-state
                    this.setState({ initialPeriod: e.target.value })
                  }
                />
              </CInputGroup>
            </CFormGroup>
          </CCol>
          <CCol style={{ maxWidth: "5%", marginTop: "10px" }}>
            <div>Até</div>
          </CCol>
          <CCol style={{ maxWidth: "25%" }}>
            <CFormGroup>
              <CInputGroup className="input-prepend">
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-calendar-o"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CInput
                  type="date"
                  value={this.state.birthday}
                  // eslint-disable-next-line react/no-unused-state
                  onChange={e => this.setState({ finalPeriod: e.target.value })}
                />
              </CInputGroup>
            </CFormGroup>
          </CCol>
        </CRow>
        {/* componente de loading */}
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <>
            <CRow style={{ marginTop: "15px" }}>
              <CCol xs={6}>
                <div>
                  <h4>Gráfico de Acessantes</h4>
                </div>
                <div>
                  <ChartWhoAccess />
                </div>
              </CCol>
              <CCol xs={6}>
                <div>
                  <h4>Gráfico de Acessos</h4>
                </div>
                <div>
                  <ChartWhoAccess />
                </div>
              </CCol>
            </CRow>

            <CRow style={{ marginTop: "35px" }}>
              <CCol xs={6}>
                <div>
                  <h4>Gráfico de Usuários (Geral)</h4>
                </div>
                <div>
                  <ChartUsers />
                </div>
              </CCol>
              <CCol xs={6}>
                <div>
                  <h4>Gráfico de Acesso às Aulas</h4>
                </div>
                <div>
                  <ChartWhoAccess />
                </div>
              </CCol>
            </CRow>

            <CRow style={{ marginTop: "80px" }}>
              <CCol xs={12}>
                <TableAccess
                  list={[
                    { name: "128", id: "100", description: "78%" },
                    { name: "90", id: "100", description: "45%" }
                  ]}
                  path="/evaluation/create/"
                  title="Visão Geral"
                  header={[
                    { name: "id", denomination: "Região" },
                    { name: "id", denomination: "Escola" },
                    { name: "id", denomination: "Turma" },
                    { name: "id", denomination: `Quant. \n Usuários` },
                    {
                      name: "id",
                      denomination: `Quant. \n Acessantes`
                    },
                    {
                      name: "id",
                      denomination: `Quant. \n Aulas`
                    },
                    {
                      name: "id",
                      denomination: "Quant. Aulas Acessadas"
                    },
                    {
                      name: "id",
                      denomination: "Quant. Acessos às Aulas"
                    },
                    {
                      name: "id",
                      denomination: "Percent. Acessos às Aulas"
                    }
                  ]}
                  csv
                />
              </CCol>
            </CRow>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Management);
